(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[98568],{

/***/ 98568:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Review_module_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2082);
/* harmony import */ var _Review_module_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_Review_module_css__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9012);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var is_mobile__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63805);
/* harmony import */ var is_mobile__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(is_mobile__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _context_TranslationContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73040);








var MobileView = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function() {
    return __webpack_require__.e(/* import() */ 28442).then(__webpack_require__.bind(__webpack_require__, 28442));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28442)
            ];
        }
    }
});
var DesktopView = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(30719), __webpack_require__.e(42883)]).then(__webpack_require__.bind(__webpack_require__, 42883));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(42883)
            ];
        }
    }
});
var Review = function(param) {
    var data = param.data;
    var ref = (0,_context_TranslationContext__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .m)(), homeReviewLeftTitleSmall = ref.homeReviewLeftTitleSmall, homeReviewLeftTitle = ref.homeReviewLeftTitle, homeReviewLeftText = ref.homeReviewLeftText, reviewsText = ref.reviews, allReviews = ref.allReviews;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), reviews = ref1[0], setReviews = ref1[1];
    var isPhone = is_mobile__WEBPACK_IMPORTED_MODULE_5___default()();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        (0,_api__WEBPACK_IMPORTED_MODULE_3__/* .HomeReviews */ .u7)().then(function(result) {
            setReviews(result.data);
        });
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex w-full",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex-auto bg-teklif-1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex container flex-col lg:flex-row px-0",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "bg-teklif-gra w-full lg:w-1/3 pt-16 pb-14 text-white flex flex-col items-center lg:items-start content-center px-12 lg:pl-[1.1rem] lg:pr-0 2xl:pl-0",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-xl",
                                children: homeReviewLeftTitleSmall
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-3xl text-center font-bold -mt-1",
                                children: homeReviewLeftTitle
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "opacity-60 mt-3 lg:pr-32 text-sm text-center lg:text-left",
                                children: homeReviewLeftText
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                href: data.url,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    title: data.title,
                                    className: "bg-brand-blue-2 font-bold text-sm text-white py-5 px-8 mt-12",
                                    children: data.kisa_baslik
                                })
                            })
                        ]
                    }),
                    reviews && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "lg:w-2/3 bg-white relative lg:pl-8 xl:pl-16 lg:pt-1 flex flex-col justify-between lg:pr-[1.1rem]  2xl:pr-0 " + (_Review_module_css__WEBPACK_IMPORTED_MODULE_7___default().ReviewWrap),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col bg-primary lg:bg-white pt-8 pb-12 lg:py-0 ",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "text-center lg:text-left text-white lg:text-orange font-bold text-lg lg:text-xl",
                                        children: reviewsText
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        href: reviews.page.url,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            title: reviews.page.title,
                                            className: "mt-2.5 text-white lg:text-primary text-xs font-bold text-center lg:text-left",
                                            children: allReviews
                                        })
                                    })
                                ]
                            }),
                            isPhone && reviews ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MobileView, {
                                data: reviews
                            }) : null,
                            !isPhone && reviews ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DesktopView, {
                                data: reviews
                            }) : null
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex-auto"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Review);


/***/ }),

/***/ 2082:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ReviewWrap":"Review_ReviewWrap__AXoao"};

/***/ })

}]);